import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=2d287f1e&scoped=true"
import script from "./workspace.vue?vue&type=script&lang=js"
export * from "./workspace.vue?vue&type=script&lang=js"
import style0 from "./workspace.vue?vue&type=style&index=0&id=2d287f1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d287f1e",
  null
  
)

export default component.exports